import { c as _c } from "react/compiler-runtime";
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { Type } from '@repo/design-system/components/ui/type';
import { css } from '@repo/panda/css';
import type React from 'react';
import { LocationContent } from '../../location-info/location-content';
interface DescriptionPreviewProps {
  description: string;
}
export const DescriptionPreview: React.FC<DescriptionPreviewProps> = t0 => {
  const $ = _c(4);
  const {
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css.raw({
      background: "wemod.elevated.100",
      borderRadius: "24",
      boxShadow: "lg",
      padding: "16",
      maxHeight: "[min(500px, calc(100vh - 56px - 16px))]",
      overflowY: "auto"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Type variant="caption" color="whiteAlpha.60">Preview</Type>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== description) {
    t3 = <FlexColumn className={t1} gap="8">{t2}<LocationContent description={description} /></FlexColumn>;
    $[2] = description;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};